import { BehaviorSubject } from 'rxjs';

export const biEventsParams$ = new BehaviorSubject({});
export const getBiEventsParams$ = () => biEventsParams$;
export const setBiEventsParams$ = (biEventsParams: object) =>
  biEventsParams$.next(biEventsParams);
